export const studyLiteralLabels: Record<string, readonly [string, string]> = {
  'Магистерская диссертация': ['Магистрлік диссертация', "Master's thesis"],
  'Докторская диссертация': ['Докторлық диссертация', 'Doctoral thesis'],
  'Дипломная работа': ['Дипломдық жұмыс', "Bachelor's thesis"],
  'Не удалось загрузить выбранный уровень': [
    'Таңдалған деңгейді жүктеу мүмкін болмады',
    'Could not load the selected level',
  ],
  'Тема выбрана и отправлена руководителю': [
    'Тақырып таңдалып, жетекшіге жіберілді',
    'Topic selected and submitted to the supervisor',
  ],
  'Не удалось выбрать тему': ['Тақырыпты таңдау мүмкін болмады', 'Could not select the topic'],
  'Укажите тему и причину отказа от предложений': [
    'Тақырыпты және ұсыныстардан бас тарту себебін көрсетіңіз',
    'Enter a topic and explain why the suggestions do not fit',
  ],
  'Собственная тема отправлена руководителю': [
    'Өз тақырыбыңыз жетекшіге жіберілді',
    'Your proposed topic was sent to the supervisor',
  ],
  'Не удалось отправить тему': ['Тақырыпты жіберу мүмкін болмады', 'Could not submit the topic'],
  'Ответ сохранён': ['Жауап сақталды', 'Answer saved'],
  'Не удалось сохранить ответ': ['Жауапты сақтау мүмкін болмады', 'Could not save the answer'],
  'Работа отправлена руководителю': [
    'Жұмыс жетекшіге жіберілді',
    'Work submitted to the supervisor',
  ],
  'Не удалось отправить задачу': ['Тапсырманы жіберу мүмкін болмады', 'Could not submit the task'],
  'Источник отправлен на согласование': [
    'Дереккөз келісуге жіберілді',
    'Source submitted for approval',
  ],
  'Не удалось добавить источник': ['Дереккөзді қосу мүмкін болмады', 'Could not add the source'],
  'Сообщение отправлено': ['Хабарлама жіберілді', 'Message sent'],
  'Не удалось отправить сообщение': [
    'Хабарламаны жіберу мүмкін болмады',
    'Could not send the message',
  ],
  'Участие подтверждено': ['Қатысу расталды', 'Attendance confirmed'],
  'Приглашение отклонено': ['Шақыру қабылданбады', 'Invitation declined'],
  'Не удалось обновить встречу': [
    'Кездесуді жаңарту мүмкін болмады',
    'Could not update the meeting',
  ],
  'Блок отправлен руководителю': [
    'Бөлім жетекшіге жіберілді',
    'Section submitted to the supervisor',
  ],
  'Не удалось отправить блок': ['Бөлімді жіберу мүмкін болмады', 'Could not submit the section'],
  'OWNER PREVIEW · ТРИ РЕЖИМА ОБУЧАЮЩЕГОСЯ': [
    'ИЕСІНЕ АРНАЛҒАН АЛДЫН АЛА ҚАРАУ · ҮШ БІЛІМ ДЕҢГЕЙІ',
    'OWNER PREVIEW · THREE STUDY LEVELS',
  ],
  'Выберите уровень образования': ['Білім деңгейін таңдаңыз', 'Select an education level'],
  'В реальном кабинете обучающийся увидит только свой назначенный уровень. Здесь три крупные кнопки оставлены для проверки владельцем.':
    [
      'Білім алушы тек тағайындалған деңгейін көреді. Үш нұсқа платформа иесінің тексеруіне арналған.',
      'Students see only their assigned level. These three options are available for owner review.',
    ],
  'Активный preview': ['Белсенді алдын ала қарау', 'Active preview'],
  'Открыть интерфейс': ['Жұмыс кабинетін ашу', 'Open workspace'],
  'OWNER PREVIEW · УРОВЕНЬ ОБУЧАЮЩЕГОСЯ': [
    'ИЕСІНЕ АРНАЛҒАН АЛДЫН АЛА ҚАРАУ · БІЛІМ ДЕҢГЕЙІ',
    'OWNER PREVIEW · STUDY LEVEL',
  ],
  'Не удалось загрузить досье. Повторите попытку позже.': [
    'Досьені жүктеу мүмкін болмады. Кейін қайталап көріңіз.',
    'Could not load the record. Please try again later.',
  ],
  'курс. Все действия и документы видны только обучающемуся и его научному руководителю.': [
    'курс. Әрекеттер мен құжаттар тек білім алушыға және оның ғылыми жетекшісіне көрінеді.',
    'year. Actions and documents are visible only to the student and their research supervisor.',
  ],
  Прогресс: ['Ілгерілеу', 'Progress'],
  'По задачам и этапам': ['Тапсырмалар мен кезеңдер бойынша', 'Tasks and milestones'],
  Рейтинг: ['Рейтинг', 'Rating'],
  Место: ['Орын', 'Rank'],
  Задач: ['Тапсырмалар', 'Tasks'],
  утверждено: ['бекітілді', 'approved'],
  Публикаций: ['Жарияланымдар', 'Publications'],
  'ВАШ НАУЧНЫЙ РУКОВОДИТЕЛЬ': ['СІЗДІҢ ҒЫЛЫМИ ЖЕТЕКШІҢІЗ', 'YOUR RESEARCH SUPERVISOR'],
  'Написать / консультация': ['Хабарлама / кеңес', 'Message / consultation'],
  'МОЙ МАРШРУТ': ['МЕНІҢ ОҚУ ЖОЛЫМ', 'MY STUDY PATH'],
  'Следующие действия': ['Келесі әрекеттер', 'Next actions'],
  'Хронология автоматически формируется по уровню, но руководитель может менять порядок, даты и добавлять этапы.':
    [
      'Хронология білім деңгейіңізге сәйкес құрылады. Жетекші ретін, күндерін және кезеңдерін өзгерте алады.',
      'The timeline follows your study level. Your supervisor can change its order, dates and milestones.',
    ],
  'Открыть всю хронологию →': ['Толық хронологияны ашу →', 'Open full timeline →'],
  ТЕМА: ['ТАҚЫРЫП', 'TOPIC'],
  'Перейти к теме': ['Тақырыпқа өту', 'Go to topic'],
  ЗАДАЧИ: ['ТАПСЫРМАЛАР', 'TASKS'],
  активных: ['белсенді', 'active'],
  'Каждая задача связана с разделами плана, сроком, ожидаемым результатом и файлами.': [
    'Әр тапсырма жоспар бөлімдерін, мерзімді, күтілетін нәтижені және файлдарды қамтиды.',
    'Each task includes plan sections, a deadline, the expected result and files.',
  ],
  'Открыть задачи': ['Тапсырмаларды ашу', 'Open tasks'],
  МАТЕРИАЛЫ: ['МАТЕРИАЛДАР', 'MATERIALS'],
  ресурсов: ['ресурстар', 'resources'],
  'Образцы руководителя доступны только для просмотра и скачивания; заменяет и обновляет их руководитель.':
    [
      'Жетекші үлгілерін көруге және жүктеп алуға болады. Оларды жетекші жаңартады.',
      'Supervisor templates can be viewed and downloaded. Your supervisor updates them.',
    ],
  'Открыть материалы': ['Материалдарды ашу', 'Open materials'],
  ВСТРЕЧИ: ['КЕЗДЕСУЛЕР', 'MEETINGS'],
  консультаций: ['кеңестер', 'consultations'],
  'Повестка, вопросы, протокол и договорённости по каждой встрече.': [
    'Әр кездесудің күн тәртібі, сұрақтары, хаттамасы және келісімдері.',
    'Agenda, questions, minutes and agreements for each meeting.',
  ],
  'Открыть консультации': ['Кеңестерді ашу', 'Open consultations'],
  'СОВМЕСТНАЯ ЛИТЕРАТУРА': ['ОРТАҚ ӘДЕБИЕТ', 'SHARED LITERATURE'],
  'разрешённых источников': ['мақұлданған дереккөздер', 'approved sources'],
  'Источники руководителя доступны сразу; предложения обучающегося проходят согласование.': [
    'Жетекшінің дереккөздері бірден қолжетімді. Білім алушы ұсыныстарына келісім қажет.',
    'Supervisor sources are available immediately. Student suggestions need approval.',
  ],
  'Открыть литературу': ['Әдебиетті ашу', 'Open literature'],
  'ПЛАН → ЗАДАЧИ': ['ЖОСПАР → ТАПСЫРМАЛАР', 'PLAN → TASKS'],
  'задач принято': ['тапсырма қабылданды', 'tasks accepted'],
  'Количество задач не равно количеству подразделов: задачи создаются по смыслу и хронологии.': [
    'Тапсырма саны жұмыс ретіне байланысты және бөлімше санына тең болуы міндетті емес.',
    'Task count follows the work sequence and does not have to match the number of subsections.',
  ],
  'Рабочие задачи': ['Жұмыс тапсырмалары', 'Work tasks'],
  'ОСНОВНАЯ РАБОТА · DEMO': ['НЕГІЗГІ ЖҰМЫС · ДЕМО', 'MAIN WORK · DEMO'],
  'блоков принято': ['бөлім қабылданды', 'sections accepted'],
  'Демонстрационный обучающийся проведён почти до предзащиты.': [
    'Демо білім алушы алдын ала қорғауға дейін жеткен.',
    'The demo student has progressed almost to pre-defense.',
  ],
  'Открыть основной этап': ['Негізгі кезеңді ашу', 'Open main stage'],
  'ЭТАП 1 · ВЫБОР И УТВЕРЖДЕНИЕ ТЕМЫ': [
    '1-КЕЗЕҢ · ТАҚЫРЫПТЫ ТАҢДАУ ЖӘНЕ БЕКІТУ',
    'STAGE 1 · TOPIC SELECTION AND APPROVAL',
  ],
  'Тема исследования': ['Зерттеу тақырыбы', 'Research topic'],
  'Руководитель предлагает минимум 3 темы. Обучающийся выбирает тему либо обосновывает отказ от предложений и формулирует собственное предложение. Затем руководитель может задать уточняющие вопросы.':
    [
      'Жетекші кемінде үш тақырып ұсынады. Біреуін таңдаңыз немесе өз ұсынысыңызды негіздеңіз. Жетекші қосымша сұрақтар қоя алады.',
      'Your supervisor offers at least three topics. Select one or explain your own proposal. The supervisor may ask follow-up questions.',
    ],
  'Что будет сделано:': ['Жоспарланған жұмыс:', 'Planned work:'],
  '✓ Выбрано': ['✓ Таңдалды', '✓ Selected'],
  'Выбрать тему': ['Тақырыпты таңдау', 'Select topic'],
  'Ожидает решения руководителя': ['Жетекшінің шешімі күтілуде', 'Awaiting supervisor decision'],
  'НЕ ПОДХОДИТ НИ ОДНА?': ['ЕШҚАЙСЫСЫ СӘЙКЕС ЕМЕС ПЕ?', 'NONE OF THESE FIT?'],
  'Предложить собственную тему': ['Өз тақырыбыңызды ұсыныңыз', 'Propose your own topic'],
  'Обязательно объясните, почему предложения руководителя не подходят, что вы хотите исследовать и какой результат рассчитываете получить.':
    [
      'Ұсынылған тақырыптардың неге сәйкес келмейтінін, нені зерттегіңіз келетінін және күтілетін нәтижені түсіндіріңіз.',
      'Explain why the suggested topics do not fit, what you want to study and the result you expect.',
    ],
  'Предложить свою тему': ['Тақырып ұсыну', 'Propose a topic'],
  'СОБСТВЕННОЕ ПРЕДЛОЖЕНИЕ': ['ӨЗ ҰСЫНЫСЫҢЫЗ', 'YOUR PROPOSAL'],
  'Обоснование:': ['Негіздеме:', 'Justification:'],
  'ВОПРОСЫ РУКОВОДИТЕЛЯ': ['ЖЕТЕКШІ СҰРАҚТАРЫ', 'SUPERVISOR QUESTIONS'],
  'Проверка исследовательского замысла': ['Зерттеу ұсынысын қарау', 'Research proposal review'],
  Ответить: ['Жауап беру', 'Answer'],
  'УТВЕРЖДЁННЫЙ ПАКЕТ': ['БЕКІТІЛГЕН ЖИНАҚ', 'APPROVED PACKAGE'],
  'Тема на трёх языках + данные научного руководителя': [
    'Үш тілдегі тақырып және ғылыми жетекші деректері',
    'Topic in three languages and research supervisor details',
  ],
  Қазақша: ['Қазақша', 'Kazakh'],
  Русский: ['Орысша', 'Russian'],
  'Сохранить 3 языка': ['Үш тілді сақтау', 'Save all three languages'],
  'ЭТАП 2 · ПЛАН ИССЛЕДОВАНИЯ': ['2-КЕЗЕҢ · ЗЕРТТЕУ ЖОСПАРЫ', 'STAGE 2 · RESEARCH PLAN'],
  'Структура работы ·': ['Жұмыс құрылымы ·', 'Work structure ·'],
  'Статус плана:': ['Жоспар мәртебесі:', 'Plan status:'],
  '. После утверждения руководителем разделы и подразделы используются как контекст задач и основной работы.':
    [
      '. Жетекші бекіткеннен кейін жоспар бөлімдері тапсырмалар мен негізгі жұмысқа негіз болады.',
      '. After supervisor approval, plan sections provide context for tasks and writing.',
    ],
  Введение: ['Кіріспе', 'Introduction'],
  Актуальность: ['Өзектілік', 'Relevance'],
  Цель: ['Мақсат', 'Aim'],
  Задачи: ['Міндеттер', 'Objectives'],
  'Основная часть': ['Негізгі бөлім', 'Main body'],
  '2–3 крупных раздела, внутри 2–4 подраздела.': [
    'Екі-үш негізгі бөлім, әрқайсысында екі-төрт бөлімше.',
    'Two to three main sections, with two to four subsections each.',
  ],
  Заключение: ['Қорытынды', 'Conclusion'],
  Выводы: ['Тұжырымдар', 'Conclusions'],
  Библиография: ['Библиография', 'Bibliography'],
  'Список литературы синхронизируется с материалами по заданиям и публикациям.': [
    'Әдебиеттер тізімі тапсырма және жарияланым материалдарымен синхрондалады.',
    'The bibliography is synchronized with task and publication materials.',
  ],
  Источники: ['Дереккөздер', 'Sources'],
  'Сохранить новую версию': ['Жаңа нұсқаны сақтау', 'Save new version'],
  'План отправлен руководителю': ['Жоспар жетекшіге жіберілді', 'Plan submitted to the supervisor'],
  'Отправить руководителю': ['Жетекшіге жіберу', 'Submit to supervisor'],
  'Перейти к связанным задачам →': ['Байланысты тапсырмаларға өту →', 'Go to related tasks →'],
  'РАБОЧИЙ ЦИКЛ · ПЛАН → ЗАДАЧИ': [
    'ЖҰМЫС ЦИКЛІ · ЖОСПАР → ТАПСЫРМАЛАР',
    'WORK CYCLE · PLAN → TASKS',
  ],
  'Задачи создаются по смыслу и хронологии': [
    'Тапсырмалар жұмыс ретімен құрылады',
    'Tasks follow the work sequence',
  ],
  'Количество задач не обязано совпадать с количеством разделов. Одна часть плана может содержать несколько последовательных задач.':
    [
      'Жоспар бөлімі бірнеше кезекті тапсырманы қамтуы мүмкін. Тапсырма мен бөлім саны әртүрлі болуы мүмкін.',
      'A plan section can have several sequential tasks. Task and section counts may differ.',
    ],
  'Описание:': ['Сипаттама:', 'Description:'],
  'Ожидаемый результат:': ['Күтілетін нәтиже:', 'Expected result:'],
  'Объём:': ['Көлем:', 'Scope:'],
  'Дедлайн:': ['Мерзім:', 'Deadline:'],
  'Связано с планом:': ['Байланысты жоспар бөлімдері:', 'Related plan sections:'],
  'Сопроводительный текст обучающегося:': ['Білім алушының ілеспе мәтіні:', 'Student cover note:'],
  'Рецензия:': ['Рецензия:', 'Review:'],
  'Обновить и отправить': ['Жаңарту және жіберу', 'Update and submit'],
  'Загрузить / отправить': ['Жүктеу / жіберу', 'Upload / submit'],
  'Задать вопрос': ['Сұрақ қою', 'Ask a question'],
  'СОВМЕСТНАЯ ЛИТЕРАТУРА ·': ['ОРТАҚ ӘДЕБИЕТ ·', 'SHARED LITERATURE ·'],
  'Библиотека научного руководителя и обучающегося': [
    'Ғылыми жетекші мен білім алушы кітапханасы',
    'Research supervisor and student library',
  ],
  'Источники научного руководителя сразу разрешены к использованию. Ваши собственные предложения сначала проверяет руководитель.':
    [
      'Жетекші дереккөздерін қолдануға рұқсат берілген. Өз ұсыныстарыңыз алдымен тексеріледі.',
      'Supervisor sources are approved for use. Your own suggestions must be reviewed first.',
    ],
  '+ Добавить источник / книгу / файл': [
    '+ Дереккөз / кітап / файл қосу',
    '+ Add source / book / file',
  ],
  'ОСНОВНОЙ ЭТАП НАПИСАНИЯ ·': ['НЕГІЗГІ ЖАЗУ КЕЗЕҢІ ·', 'MAIN WRITING STAGE ·'],
  'Структура работы синхронизируется с утверждённым планом': [
    'Жұмыс құрылымы бекітілген жоспарға сәйкес',
    'The work structure follows the approved plan',
  ],
  'Титульные листы, задание, содержание, введение, разделы плана, заключение, литература и приложения превращаются в рабочие блоки обучающегося.':
    [
      'Титул парағы, тапсырма, мазмұн, кіріспе, жоспар бөлімдері, қорытынды, әдебиет және қосымшалар жұмыс бөлімдеріне айналады.',
      'Title pages, objectives, contents, introduction, plan sections, conclusion, references and appendices become work sections.',
    ],
  Структура: ['Құрылым', 'Structure'],
  блоков: ['бөлім', 'sections'],
  'Общий дедлайн': ['Жалпы мерзім', 'Overall deadline'],
  'Финальный файл': ['Қорытынды файл', 'Final file'],
  'Структура ещё не отправлена научным руководителем.': [
    'Ғылыми жетекші құрылымды әзірге жіберген жоқ.',
    'Your research supervisor has not sent the structure yet.',
  ],
  'НЕОБЯЗАТЕЛЬНЫЙ БЛОК': ['МІНДЕТТІ ЕМЕС БӨЛІМ', 'OPTIONAL SECTION'],
  'ОБЯЗАТЕЛЬНЫЙ БЛОК': ['МІНДЕТТІ БӨЛІМ', 'REQUIRED SECTION'],
  'Текст / пояснение / что загружено по этому блоку': [
    'Мәтін / түсіндірме / жүктелген мазмұн',
    'Text / explanation / uploaded content',
  ],
  'Загрузить документ и отправить': ['Құжатты жүктеу және жіберу', 'Upload document and submit'],
  'ИТОГОВАЯ СБОРКА И ПРЕДВАРИТЕЛЬНАЯ ПРОВЕРКА': [
    'ҚОРЫТЫНДЫ ЖИНАҚТАУ ЖӘНЕ АЛДЫН АЛА ТЕКСЕРУ',
    'FINAL ASSEMBLY AND PRELIMINARY CHECK',
  ],
  'Собрать общий материал': ['Толық жұмысты жинақтау', 'Assemble full work'],
  'После принятия рабочих блоков руководитель собирает единую версию и прикрепляет результат предварительного антиплагиата.':
    [
      'Бөлімдерді қабылдағаннан кейін жетекші жұмысты жинақтап, алдын ала антиплагиат нәтижесін тіркейді.',
      'After accepting the sections, your supervisor assembles the work and attaches the preliminary plagiarism check.',
    ],
  'Предварительная проверка руководителя пройдена': [
    'Жетекшінің алдын ала тексеруі өтті',
    'Supervisor preliminary check passed',
  ],
  'Итоговая проверка ещё не завершена': [
    'Қорытынды тексеру әлі аяқталмаған',
    'Final check is not complete yet',
  ],
  'Файл:': ['Файл:', 'File:'],
  'Антиплагиат:': ['Антиплагиат:', 'Plagiarism check:'],
  'Вы можете загружать, заменять и удалять общие материалы выбранного уровня.': ['Таңдалған деңгейдің ортақ материалдарын жүктеуге, ауыстыруға және жоюға болады.', 'You can upload, replace and delete shared materials for the selected level.'],
  'ОБЩИЕ МАТЕРИАЛЫ УРОВНЯ': ['БІЛІМ ДЕҢГЕЙІНІҢ ОРТАҚ МАТЕРИАЛДАРЫ', 'SHARED LEVEL MATERIALS'],
  'Образцы, положения и документы ·': [
    'Үлгілер, ережелер және құжаттар ·',
    'Templates, regulations and documents ·',
  ],
  'Это единый набор материалов для вашего уровня. Вы можете просматривать и скачивать их; редактирует и заменяет только научный руководитель.':
    [
      'Бұлар білім деңгейіңіздің ортақ материалдары. Оларды көруге және жүктеп алуға болады. Тек жетекші жаңарта алады.',
      'These are shared materials for your study level. You may view and download them. Only your supervisor can update them.',
    ],
  'ИССЛЕДОВАТЕЛЬСКИЕ РЕЗУЛЬТАТЫ': ['ЗЕРТТЕУ НӘТИЖЕЛЕРІ', 'RESEARCH RESULTS'],
  ', статьи, конференции и evidence': [
    ', мақалалар, конференциялар және растаушы материалдар',
    ', articles, conferences and supporting evidence',
  ],
  'Для бакалавриата предусмотрена как минимум одна апробация / конференция и основной результат дипломной работы.':
    [
      'Бакалаврларға кемінде бір конференция немесе апробация және дипломдық жұмыстың негізгі нәтижесі қажет.',
      "Bachelor's students need at least one conference or research presentation and the main thesis result.",
    ],
  'Основной отчёт и evidence хранятся раздельно: статьи, сертификаты, акты, данные и материалы практики.':
    [
      'Негізгі есеп мақалалардан, сертификаттардан, актілерден, деректерден және практика материалдарынан бөлек сақталады.',
      'The main report is stored separately from articles, certificates, records, data and internship materials.',
    ],
  'Отчёт не загружен': ['Есеп жүктелмеген', 'Report not uploaded'],
  'Отчёт отправлен': ['Есеп жіберілді', 'Report submitted'],
  'Загрузить отчёт': ['Есепті жүктеу', 'Upload report'],
  'Подтверждение добавлено': ['Растау қосылды', 'Evidence added'],
  '+ Подтверждение': ['+ Растау', '+ Evidence'],
  'Публикации / конференции': ['Жарияланымдар / конференциялар', 'Publications / conferences'],
  'Результаты по теме: журнал или конференция, статус, venue и подтверждающий файл.': [
    'Журнал немесе конференция нәтижелері, мәртебесі, орны және растаушы файлы.',
    'Journal or conference results, status, venue and supporting file.',
  ],
  'Файл публикации обновлён': ['Жарияланым файлы жаңартылды', 'Publication file updated'],
  'Заменить / добавить файл': ['Файлды ауыстыру / қосу', 'Replace / add file'],
  '+ Файл': ['+ Файл', '+ File'],
  'Публикации ещё не добавлены': ['Жарияланымдар әзірге қосылмаған', 'No publications added yet'],
  'Публикация добавлена': ['Жарияланым қосылды', 'Publication added'],
  '+ Добавить публикацию / конференцию': [
    '+ Жарияланым / конференция қосу',
    '+ Add publication / conference',
  ],
  'Литература, библиография и материалы по разделам': [
    'Әдебиет, библиография және бөлім материалдары',
    'Literature, bibliography and section materials',
  ],
  'Источник или файл связывается с конкретным разделом утверждённого плана и остаётся видимым обеим сторонам.':
    [
      'Дереккөз немесе файл бекітілген жоспар бөлімімен байланысады және екі тарапқа көрінеді.',
      'A source or file is linked to an approved plan section and remains visible to both parties.',
    ],
  Раздел: ['Бөлім', 'Section'],
  'Материалы по разделам ещё не добавлены': [
    'Бөлім материалдары әзірге қосылмаған',
    'No section materials added yet',
  ],
  '+ Добавить источник / файл': ['+ Дереккөз / файл қосу', '+ Add source / file'],
  'Открыть совместную литературу': ['Ортақ әдебиетті ашу', 'Open shared literature'],
  'НИР / ПРАКТИКИ / СТАЖИРОВКА · ЕДИНЫЙ ЦИКЛ': [
    'ҒЗЖ / ПРАКТИКА / ТАҒЫЛЫМДАМА · ОРТАҚ ЦИКЛ',
    'RESEARCH / PRACTICE / INTERNSHIP · SHARED CYCLE',
  ],
  '· отчёт → проверка → доработка → утверждение': [
    '· есеп → тексеру → түзету → бекіту',
    '· report → review → changes → approval',
  ],
  'Для НИР, практики и научной стажировки применяется та же логика обмена файлами и рецензирования.':
    [
      'ҒЗЖ, практика және тағылымдама бірдей файл алмасу және тексеру тәртібін қолданады.',
      'Research, practice and internships use the same file exchange and review process.',
    ],
  'Материал отправлен': ['Материал жіберілді', 'Material submitted'],
  'Загрузить и отправить': ['Жүктеу және жіберу', 'Upload and submit'],
  'РЕДАКТИРУЕМАЯ ХРОНОЛОГИЯ': ['ӨЗГЕРТІЛЕТІН ХРОНОЛОГИЯ', 'EDITABLE TIMELINE'],
  'Вы видите утверждённый руководителем порядок, даты и статусы. Изменения синхронизируются автоматически.':
    [
      'Жетекші бекіткен ретті, күндерді және мәртебелерді көресіз. Өзгерістер автоматты синхрондалады.',
      'You see the sequence, dates and statuses approved by your supervisor. Changes are synchronized automatically.',
    ],
  'ВСТРЕЧИ · КОНСУЛЬТАЦИИ · ПРИГЛАШЕНИЯ': [
    'КЕЗДЕСУЛЕР · КЕҢЕСТЕР · ШАҚЫРУЛАР',
    'MEETINGS · CONSULTATIONS · INVITATIONS',
  ],
  'Мои консультации': ['Менің кеңестерім', 'My consultations'],
  'Каждая встреча имеет дату, повестку, вопросы, протокол и следующие действия.': [
    'Әр кездесудің күні, күн тәртібі, сұрақтары, хаттамасы және келесі әрекеттері бар.',
    'Each meeting has a date, agenda, questions, minutes and next actions.',
  ],
  Принять: ['Қабылдау', 'Accept'],
  Отклонить: ['Қабылдамау', 'Decline'],
  'ОБЩАЯ ПЕРЕПИСКА': ['ЖАЛПЫ ХАТ АЛМАСУ', 'GENERAL MESSAGES'],
  'Руководитель ↔ обучающийся': ['Жетекші ↔ білім алушы', 'Supervisor ↔ student'],
  'Вопросы по заданиям остаются внутри задач, общие вопросы и договорённости — здесь.': [
    'Тапсырма сұрақтары тапсырмаларда қалады. Жалпы сұрақтар мен келісімдер осында жазылады.',
    'Task questions stay within tasks. General questions and agreements are recorded here.',
  ],
  '+ Сообщение': ['+ Хабарлама', '+ Message'],
  'ФИНАЛЬНЫЙ МАРШРУТ': ['ҚОРЫТЫНДЫ ОҚУ ЖОЛЫ', 'FINAL STUDY PATH'],
  '· подготовка к защите': ['· қорғауға дайындық', '· defense preparation'],
  'Сроки и порядок редактируются руководителем. Для каждого этапа можно хранить результат, комментарий и подтверждающий документ.':
    [
      'Жетекші күндер мен ретті өзгертеді. Әр кезеңде нәтиже, пікір және растаушы құжат болуы мүмкін.',
      'Your supervisor edits dates and sequence. Each stage can include a result, comment and supporting document.',
    ],
  'Текущий контрольный этап': ['Ағымдағы бақылау кезеңі', 'Current checkpoint'],
  'Следующий этап': ['Келесі кезең', 'Next stage'],
  'СКВОЗНАЯ ФИНАЛЬНАЯ ТРАЕКТОРИЯ': ['ТОЛЫҚ ҚОРЫТЫНДЫ ЖОЛ', 'FULL FINAL PATH'],
  'От полной работы до основной защиты': [
    'Толық жұмыстан негізгі қорғауға дейін',
    'From full work to final defense',
  ],
  'Этапы дополняют ранее утверждённый маршрут и не заменяют существующие требования конкретного уровня.':
    [
      'Бұл кезеңдер бекітілген жолды толықтырады және білім деңгейінің талаптарын сақтайды.',
      'These stages add to the approved path and preserve the requirements for your level.',
    ],
  'AI-помощник обучающегося': ['Білім алушының AI-көмекшісі', 'Student AI assistant'],
  'AI не утверждает научные решения автоматически. Он готовит проект, который должен проверить человек.':
    [
      'AI адам тексеретін жоба дайындайды. Ғылыми шешімдерді автоматты бекітпейді.',
      'AI prepares drafts for human review. It does not approve research decisions automatically.',
    ],
  'Темы исследования': ['Зерттеу тақырыптары', 'Research topics'],
  'Вопросы по теме': ['Тақырып сұрақтары', 'Topic questions'],
  'Проверить структуру': ['Құрылымды тексеру', 'Check structure'],
  'Разбить на задачи': ['Тапсырмаларға бөлу', 'Split into tasks'],
  'Риски сроков': ['Мерзім тәуекелдері', 'Deadline risks'],
  'Черновик комментария': ['Пікір жобасы', 'Draft comment'],
  ПРАВИЛО: ['ЕРЕЖЕ', 'RULE'],
  'Любая тема, оценка, комментарий, изменение плана или решение по защите остаётся под контролем научного руководителя.':
    [
      'Тақырыптар, бағалар, пікірлер, жоспар өзгерістері және қорғау шешімдері ғылыми жетекшінің бақылауында қалады.',
      'Your research supervisor retains control of topics, grades, comments, plan changes and defense decisions.',
    ],
  'ОФИЦИАЛЬНЫЕ ИСТОЧНИКИ ENU · EVIDENCE FIRST': [
    'ЕҰУ РЕСМИ ДЕРЕККӨЗДЕРІ · РАСТАЛҒАН МАТЕРИАЛДАР',
    'OFFICIAL ENU SOURCES · VERIFIED EVIDENCE',
  ],
  'Проверенные точки входа университета': [
    'Университеттің тексерілген ресурстары',
    'Verified university resources',
  ],
  'Этот раздел содержит только официальные домены ENU. Для требований, сроков и форм документов всегда применяется актуальная версия официальной страницы на момент действия.':
    [
      'Тек ЕҰУ ресми домендері берілген. Талаптар, мерзімдер және құжат нысандары үшін ресми беттің өзекті нұсқасын қолданыңыз.',
      'Only official ENU domains are listed. Use the current official page for requirements, deadlines and document forms.',
    ],
  'Открыть официальный источник ↗': ['Ресми дереккөзді ашу ↗', 'Open official source ↗'],
  Назад: ['Артқа', 'Back'],
  '← Назад': ['← Артқа', '← Back'],
  'Научная работа под руководством': [
    'Жетекшілікпен ғылыми жұмыс',
    'Research work under supervision',
  ],
  'Тема · план · задачи · совместная литература · основная работа · образцы и документы · НИР · практика · консультации · защита.':
    [
      'Тақырып · жоспар · тапсырмалар · ортақ әдебиет · негізгі жұмыс · үлгілер · ҒЗЖ · практика · кеңестер · қорғау.',
      'Topic · plan · tasks · shared literature · main work · templates · research · practice · consultations · defense.',
    ],
  Закрыть: ['Жабу', 'Close'],
  'Закрыть ×': ['Жабу ×', 'Close ×'],
  'курс ·': ['курс ·', 'year ·'],
  Тема: ['Тақырып', 'Topic'],
  'Почему не подходят предложения': [
    'Ұсыныстардың сәйкес келмеу себебі',
    'Why the suggestions do not fit',
  ],
  'Ожидаемый результат': ['Күтілетін нәтиже', 'Expected result'],
  'Сопроводительный текст': ['Ілеспе мәтін', 'Cover note'],
  Название: ['Атауы', 'Title'],
  'Раздел плана': ['Жоспар бөлімі', 'Plan section'],
  Комментарий: ['Пікір', 'Comment'],
  Текст: ['Мәтін', 'Text'],
  Отмена: ['Бас тарту', 'Cancel'],
  'ОТ РУКОВОДИТЕЛЯ': ['ЖЕТЕКШІДЕН', 'FROM SUPERVISOR'],
  'ОТ ОБУЧАЮЩЕГОСЯ': ['БІЛІМ АЛУШЫДАН', 'FROM STUDENT'],
  'Раздел:': ['Бөлім:', 'Section:'],
  Присутствовал: ['Қатысты', 'Present'],
  Уважительная: ['Дәлелді себеп', 'Excused'],
  Отсутствовал: ['Қатыспады', 'Absent'],
  'Вернуться в кабинет': ['Кабинетке оралу', 'Back to workspace'],
  'Кабинет обучающегося': ['Білім алушы кабинеті', 'Student workspace'],
  Обучающийся: ['Білім алушы', 'Student'],
  'Дисциплины · материалы · задания · оценки · посещаемость · календарь · работы и учебные документы.':
    [
      'Пәндер · материалдар · тапсырмалар · бағалар · қатысу · күнтізбе · жұмыстар мен оқу құжаттары.',
      'Courses · materials · assignments · grades · attendance · calendar · work and academic documents.',
    ],
  'Связь с преподавателем': ['Оқытушымен байланыс', 'Contact teacher'],
  'АКТИВНАЯ ДИСЦИПЛИНА · 2026–2027 · ОСЕННИЙ СЕМЕСТР': [
    'БЕЛСЕНДІ ПӘН · 2026–2027 · КҮЗГІ СЕМЕСТР',
    'ACTIVE COURSE · 2026–2027 · AUTUMN SEMESTER',
  ],
  'Учебный раздел': ['Оқу бөлімі', 'Study section'],
  дисциплины: ['пәндер', 'courses'],
  'текущий семестр': ['ағымдағы семестр', 'current semester'],
  сегодня: ['бүгін', 'today'],
  занятия: ['сабақтар', 'lessons'],
  дедлайны: ['мерзімдер', 'deadlines'],
  'требуют действия': ['әрекет қажет', 'need action'],
  'мой прогресс': ['менің ілгерілеуім', 'my progress'],
  'по выбранной дисциплине': ['таңдалған пән бойынша', 'selected course'],
  'УЧЕБНЫЙ РАЗДЕЛ · МОЯ ДИСЦИПЛИНА': ['ОҚУ БӨЛІМІ · МЕНІҢ ПӘНІМ', 'STUDY SECTION · MY COURSE'],
  '· преподаватель:': ['· оқытушы:', '· teacher:'],
  'Текущий балл': ['Ағымдағы балл', 'Current score'],
  'из 100': ['100-ден', 'out of 100'],
  Посещаемость: ['Қатысу', 'Attendance'],
  Задания: ['Тапсырмалар', 'Assignments'],
  'по дисциплине': ['осы пән бойынша', 'for this course'],
  'На проверке': ['Тексеруге жіберілді', 'Submitted for review'],
  'ожидают решения': ['шешім күтілуде', 'awaiting decision'],
  'Показать занятия': ['Сабақтарды көрсету', 'Show lessons'],
  'Образцы и документы': ['Үлгілер мен құжаттар', 'Templates and documents'],
  'БЛИЖАЙШИЙ ДЕДЛАЙН': ['ЕҢ ЖАҚЫН МЕРЗІМ', 'NEXT DEADLINE'],
  'Следующее действие': ['Келесі әрекет', 'Next action'],
  'Карточка сокращена специально для боковой области: без обрезки рубрики и кнопок.': [
    'Карточка бағалау өлшемдерін және әрекет батырмаларын қамтиды.',
    'The card includes the rubric and action buttons.',
  ],
  'СРО · неделя': ['Өзіндік жұмыс · апта', 'Independent work · week'],
  '· до': ['· мерзімі', '· due'],
  'баллов.': ['балл.', 'points.'],
  'Загрузить новую версию': ['Жаңа нұсқаны жүктеу', 'Upload new version'],
  'КОНТРОЛЬНЫЕ ТОЧКИ СЕМЕСТРА': ['СЕМЕСТРДІҢ БАҚЫЛАУ КЕЗЕҢДЕРІ', 'SEMESTER CHECKPOINTS'],
  'РК1 · РК2 · итоговый контроль': [
    'АБ1 · АБ2 · қорытынды бақылау',
    'Assessment 1 · Assessment 2 · final assessment',
  ],
  'Контрольные точки видны заранее и связаны с оценками дисциплины.': [
    'Бақылау кезеңдері алдын ала көрсетіліп, пән бағаларымен байланысады.',
    'Checkpoints are shown in advance and linked to course grades.',
  ],
  'КОНТРОЛЬНАЯ ТОЧКА · 7 неделя': ['БАҚЫЛАУ КЕЗЕҢІ · 7-АПТА', 'CHECKPOINT · WEEK 7'],
  'Рубежный контроль 1': ['Аралық бақылау 1', 'Assessment 1'],
  'Запланировано на 7 неделя.': ['7-аптаға жоспарланған.', 'Scheduled for week 7.'],
  Запланировано: ['Жоспарланған', 'Scheduled'],
  'КОНТРОЛЬНАЯ ТОЧКА · 15 неделя': ['БАҚЫЛАУ КЕЗЕҢІ · 15-АПТА', 'CHECKPOINT · WEEK 15'],
  'Рубежный контроль 2': ['Аралық бақылау 2', 'Assessment 2'],
  'Запланировано на 15 неделя.': ['15-аптаға жоспарланған.', 'Scheduled for week 15.'],
  'ИТОГОВЫЙ КОНТРОЛЬ': ['ҚОРЫТЫНДЫ БАҚЫЛАУ', 'FINAL ASSESSMENT'],
  'Итоговый контроль / экзамен': ['Қорытынды бақылау / емтихан', 'Final assessment / exam'],
  'После учебных недель дисциплины.': [
    'Пәннің оқу апталарынан кейін.',
    'After the course teaching weeks.',
  ],
  'Дисциплины текущего семестра': ['Ағымдағы семестр пәндері', 'Current semester courses'],
  'Преподаватель:': ['Оқытушы:', 'Teacher:'],
  'Кредиты:': ['Кредиттер:', 'Credits:'],
  'Балл:': ['Балл:', 'Score:'],
  Выбрать: ['Таңдау', 'Select'],
  'Занятия и материалы:': ['Сабақтар мен материалдар:', 'Lessons and materials:'],
  Неделя: ['Апта', 'Week'],
  Лекция: ['Дәріс', 'Lecture'],
  'Практика / Семинар': ['Практика / семинар', 'Practice / seminar'],
  'СРО:': ['Өзіндік жұмыс:', 'Independent work:'],
  'СРОП:': ['Оқытушымен өзіндік жұмыс:', 'Supervised independent work:'],
  'МОИ ЗАДАНИЯ': ['МЕНІҢ ТАПСЫРМАЛАРЫМ', 'MY ASSIGNMENTS'],
  'Нужно выполнить · отправлено · на проверке · возвращено на доработку · повторная сдача · оценено. Все версии работы сохраняются и открываются без обрезки.':
    [
      'Орындау қажет · жіберілді · тексерілуде · түзету қажет · қайта тапсырылды · бағаланды. Барлық нұсқалар сақталады.',
      'To do · submitted · under review · changes required · resubmitted · graded. All versions are retained.',
    ],
  '· максимум': ['· ең жоғары', '· maximum'],
  Опубликовано: ['Жарияланды', 'Published'],
  'б.': ['б.', 'pts.'],
  Версия: ['Нұсқа', 'Version'],
  'В портфолио': ['Портфолиода', 'In portfolio'],
  'МОЙ ПРОГРЕСС': ['МЕНІҢ ІЛГЕРІЛЕУІМ', 'MY PROGRESS'],
  'текущий балл из': ['ағымдағы балл', 'current score out of'],
  Практика: ['Практика', 'Practice'],
  'текущий вклад': ['ағымдағы үлес', 'current contribution'],
  СРО: ['Өзіндік жұмыс', 'Independent work'],
  'Рубежный контроль': ['Аралық бақылау', 'Assessment'],
  'по контрольным точкам': ['бақылау кезеңдері бойынша', 'at checkpoints'],
  'ОЦЕНКИ ПО РАБОТАМ': ['ТАПСЫРМА БАҒАЛАРЫ', 'ASSIGNMENT GRADES'],
  'Из чего сформирован балл': ['Балл құрамы', 'Score breakdown'],
  '· дедлайн': ['· мерзімі', '· deadline'],
  'РУБЕЖНЫЙ И ИТОГОВЫЙ КОНТРОЛЬ': ['АРАЛЫҚ ЖӘНЕ ҚОРЫТЫНДЫ БАҚЫЛАУ', 'INTERIM AND FINAL ASSESSMENT'],
  'Рейтинг допуска (РК1 + РК2)': [
    'Жіберу рейтингі (АБ1 + АБ2)',
    'Admission rating (assessment 1 + 2)',
  ],
  'РК1 — 7 неделя, РК2 — 15 неделя, далее итоговый контроль / экзамен.': [
    'АБ1 — 7-апта, АБ2 — 15-апта, кейін қорытынды бақылау немесе емтихан.',
    'Assessment 1 in week 7, assessment 2 in week 15, then the final assessment or exam.',
  ],
  ПОСЕЩАЕМОСТЬ: ['ҚАТЫСУ', 'ATTENDANCE'],
  'Журнал посещаемости занятий': ['Сабаққа қатысу журналы', 'Lesson attendance register'],
  'Присутствие, отсутствие, опоздание и возможная отработка фиксируются по занятиям.': [
    'Әр сабаққа қатысу, қатыспау, кешігу және өтелген жұмыс тіркеледі.',
    'Presence, absence, lateness and make-up work are recorded for each lesson.',
  ],
  'текущий показатель': ['ағымдағы көрсеткіш', 'current rate'],
  'Учтено занятий': ['Тіркелген сабақтар', 'Lessons recorded'],
  период: ['кезең', 'period'],
  Пропуски: ['Қатыспаулар', 'Absences'],
  зафиксировано: ['тіркелді', 'recorded'],
  Опоздания: ['Кешігулер', 'Late arrivals'],
  'ОБРАЗЦЫ И ДОКУМЕНТЫ · ВНУТРИ УЧЕБНОГО РАЗДЕЛА': [
    'ҮЛГІЛЕР МЕН ҚҰЖАТТАР · ОҚУ БӨЛІМІ',
    'TEMPLATES AND DOCUMENTS · STUDY SECTION',
  ],
  'Как оформлять и сдавать учебные работы': [
    'Оқу жұмыстарын дайындау және тапсыру',
    'How to prepare and submit coursework',
  ],
  'Курсовая работа, презентация, эссе, СРО, библиография и актуальные документы дисциплины собраны в одном месте.':
    [
      'Курстық жұмыстар, презентациялар, эсселер, өзіндік жұмыстар, әдебиеттер және пән құжаттары осында жиналған.',
      'Course papers, presentations, essays, independent work, references and course documents are collected here.',
    ],
  КАЛЕНДАРЬ: ['КҮНТІЗБЕ', 'CALENDAR'],
  'Занятия, дедлайны, СРОП и проекты': [
    'Сабақтар, мерзімдер, оқытушымен жұмыс және жобалар',
    'Lessons, deadlines, supervised work and projects',
  ],
  ОБРАЩЕНИЯ: ['ӨТІНІШТЕР', 'REQUESTS'],
  'Написать вопрос': ['Сұрақ жазу', 'Ask a question'],
  'Нет активных обращений по данной дисциплине.': [
    'Бұл пән бойынша белсенді өтініштер жоқ.',
    'No active requests for this course.',
  ],
  'Ответ преподавателя:': ['Оқытушы жауабы:', 'Teacher response:'],
  'МОИ РАБОТЫ / ПОРТФОЛИО': ['МЕНІҢ ЖҰМЫСТАРЫМ / ПОРТФОЛИО', 'MY WORK / PORTFOLIO'],
  'Учебные и выбранные внеучебные результаты': [
    'Оқу және таңдалған оқудан тыс нәтижелер',
    'Academic and selected extracurricular results',
  ],
  'Отправленные работы, проекты и презентации сохраняются по годам. Отдельно можно добавить научный проект в академическое портфолио.':
    [
      'Тапсырылған жұмыстар, жобалар және презентациялар жылдар бойынша сақталады. Ғылыми жобаларды портфолиоға қосуға болады.',
      'Submitted work, projects and presentations are retained by year. Research projects can be added to the portfolio.',
    ],
  '★ ПОРТФОЛИО': ['★ ПОРТФОЛИО', '★ PORTFOLIO'],
  'МОЯ РАБОТА': ['МЕНІҢ ЖҰМЫСЫМ', 'MY WORK'],
  '★ В портфолио': ['★ Портфолиода', '★ In portfolio'],
  '☆ Добавить в портфолио': ['☆ Портфолиоға қосу', '☆ Add to portfolio'],
  'Комментарий преподавателя': ['Оқытушы пікірі', 'Teacher comment'],
  'Результат согласуется с руководителем.': [
    'Нәтиже жетекшімен келісіледі.',
    'The result will be agreed with your supervisor.',
  ],
  'Ответ ещё не дан': ['Жауап әлі берілмеген', 'No answer yet'],
  'По согласованному объёму': ['Келісілген көлем бойынша', 'According to the agreed scope'],
  Бакалавриат: ['Бакалавриат', "Bachelor's studies"],
  НИР: ['ҒЗЖ', 'Research work'],
  'Исследовательский результат': ['Зерттеу нәтижесі', 'Research result'],
  'Без комментария': ['Пікір жоқ', 'No comment'],
  Материал: ['Материал', 'Material'],
  'Повестка откроется у руководителя': [
    'Күн тәртібін жетекші береді',
    'The supervisor will provide the agenda',
  ],
  'Собственная тема': ['Өз тақырыбыңыз', 'Your own topic'],
  'Ответ руководителю': ['Жетекшіге жауап', 'Answer to supervisor'],
  'Отправить работу': ['Жұмысты жіберу', 'Submit work'],
  'Новый источник': ['Жаңа дереккөз', 'New source'],
  'Сообщение руководителю': ['Жетекшіге хабарлама', 'Message to supervisor'],
  'Без привязки': ['Байланыстырылмаған', 'Not linked'],
  'Без файла': ['Файл жоқ', 'No file'],
  'Окно консультации не задано': ['Кеңес уақыты көрсетілмеген', 'Consultation hours not specified'],
  'Срок не задан': ['Мерзім көрсетілмеген', 'Deadline not specified'],
  'Рейтинг допуска (РК1 + РК2) рассчитывается согласно силлабусу: (РК1 + РК2)/2 >= 50': [
    'Жіберу рейтингі силлабус бойынша есептеледі: (АБ1 + АБ2)/2 >= 50',
    'Admission rating follows the syllabus: (assessment 1 + assessment 2)/2 >= 50',
  ],
  Занятие: ['Сабақ', 'Lesson'],
  'ЗАГРУЗИТЬ НОВУЮ ВЕРСИЮ': ['ЖАҢА НҰСҚАНЫ ЖҮКТЕУ', 'UPLOAD NEW VERSION'],
  'Текущая версия:': ['Ағымдағы нұсқа:', 'Current version:'],
  'Новая версия:': ['Жаңа нұсқа:', 'New version:'],
  '(будет отправлена на проверку)': ['(тексеруге жіберіледі)', '(will be submitted for review)'],
  'Файл работы (до 20 МБ)': ['Жұмыс файлы (20 МБ дейін)', 'Work file (up to 20 MB)'],
  'Файл работы': ['Жұмыс файлы', 'Work file'],
  'Комментарий для преподавателя (исправления, ссылки)': [
    'Оқытушыға пікір (түзетулер, сілтемелер)',
    'Note to teacher (changes, links)',
  ],
  'Укажите, какие замечания были учтены в этой версии работы...': [
    'Осы нұсқада қандай ескертулер ескерілгенін көрсетіңіз...',
    'Describe the feedback addressed in this version of your work...',
  ],
  'Отправка...': ['Жіберілуде...', 'Submitting...'],
  'Описание и правила оформления:': [
    'Сипаттама және рәсімдеу ережелері:',
    'Description and formatting rules:',
  ],
  'Формат файла:': ['Файл пішімі:', 'File format:'],
  'Размер:': ['Көлемі:', 'Size:'],
  'Скачать шаблон': ['Үлгіні жүктеп алу', 'Download template'],
};
